import { BID_SALE_AUCTION_STATUS } from 'constants/bidSale';
import getDealWorkingOfferStatus from './dealWorking';
import getFailedOfferStatus from './failed';
import getLiveOfferStatus from './live';
import getOvertimeOfferStatus from './overtime';
import getPendingOfferStatus from './pending';
import getSoldOfferStatus from './sold';
import getEndedOfferStatus from './ended';

export const getOfferStatus = ({ vehicle, overrideDateNow, currentUserTopOfferer }) => {
	const { bid_sale_auction_status } = vehicle;
	switch (bid_sale_auction_status) {
		case BID_SALE_AUCTION_STATUS.live:
			return getLiveOfferStatus({ vehicle, currentUserTopOfferer });
		case BID_SALE_AUCTION_STATUS.overtime:
			return getOvertimeOfferStatus({ vehicle, currentUserTopOfferer, overrideDateNow });
		case BID_SALE_AUCTION_STATUS.deal_working:
			return getDealWorkingOfferStatus({ vehicle, currentUserTopOfferer });
		case BID_SALE_AUCTION_STATUS.sold:
			return getSoldOfferStatus({ vehicle, currentUserTopOfferer });
		case BID_SALE_AUCTION_STATUS.failed:
			return getFailedOfferStatus();
		case BID_SALE_AUCTION_STATUS.ended:
			return getEndedOfferStatus({ vehicle, currentUserTopOfferer });
		case BID_SALE_AUCTION_STATUS.pending:
		default:
			return getPendingOfferStatus({ vehicle });
	}
};
